import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import FormTextField from '../../../components/Form/FormTextField/FormTextField';
import { PRIMARY_FONT } from '../../../theme/fontConstants';
import { validateHoursField, validateStipendField } from '../helpers/validationHelpers';

const StipendSection = ({ hasStipend, setHasStipend }) => {
  const theme = useTheme();

  const sectionHeaderStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '20px',
    fontFamily: PRIMARY_FONT[700],
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(3),
  };

  const questionStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    marginBottom: theme.spacing(1),
  };

  return (
    <>
      <Typography sx={sectionHeaderStyle}>
        {LanguageConverterV2('contract.create.stipend')}
      </Typography>

      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.stipendQuestion')}
      </Typography>
      <FormControl component="fieldset" sx={{ mb: 3 }}>
        <RadioGroup
          value={hasStipend ? 'yes' : 'no'}
          onChange={(e) => setHasStipend(e.target.value === 'yes')}
        >
          <FormControlLabel
            value="yes"
            control={<Radio />}
            label={LanguageConverterV2('contract.create.stipendYes')}
          />
          <FormControlLabel
            value="no"
            control={<Radio />}
            label={LanguageConverterV2('contract.create.stipendNo')}
          />
        </RadioGroup>
      </FormControl>

      {hasStipend && (
        <>
          <Typography sx={questionStyle}>
            {LanguageConverterV2('contract.create.stipendAmountQuestion')}
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <Field name="mealAmount" validate={validateStipendField}>
                {({ input, meta }) => (
                  <FormTextField
                    input={input}
                    meta={meta}
                    label={LanguageConverterV2('contract.create.mealAmount')}
                    placeholder={LanguageConverterV2('contract.create.placeholder.meal')}
                    required
                    fullWidth
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field name="lodgingAmount" validate={validateStipendField}>
                {({ input, meta }) => (
                  <FormTextField
                    input={input}
                    meta={meta}
                    label={LanguageConverterV2('contract.create.lodgingAmount')}
                    placeholder={LanguageConverterV2('contract.create.placeholder.lodging')}
                    required
                    fullWidth
                  />
                )}
              </Field>
            </Grid>
          </Grid>

          <Typography sx={questionStyle}>
            {LanguageConverterV2('contract.create.hoursQuestion')}
          </Typography>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6}>
              <Field name="targetHours" validate={validateHoursField}>
                {({ input, meta }) => (
                  <FormTextField
                    input={input}
                    meta={meta}
                    label={LanguageConverterV2('contract.create.targetHours')}
                    placeholder={LanguageConverterV2('contract.create.placeholder.hours')}
                    required
                    fullWidth
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Field name="prorateDropOff" validate={validateHoursField}>
                {({ input, meta }) => (
                  <FormTextField
                    input={input}
                    meta={meta}
                    label={LanguageConverterV2('contract.create.prorateDropOff')}
                    placeholder={LanguageConverterV2('contract.create.placeholder.prorate')}
                    required
                    fullWidth
                  />
                )}
              </Field>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

StipendSection.propTypes = {
  hasStipend: PropTypes.bool.isRequired,
  setHasStipend: PropTypes.func.isRequired,
};

export default StipendSection;
